import React, { VFCX } from 'react';
import { CategoryLabel, CategoryContainer, CategoryTopImage } from 'src/components/Top';
import { GatsbyLinkButton } from 'src/components/common/molecules';

import LanguageGroup from './language-group';
import Description from './description';

const Component: VFCX = () => (
  <CategoryContainer color='var(--bg)'>
    <CategoryTopImage filename='gummy-designer-tools.svg' size={18} />
    <CategoryLabel label='Skills and Tools' color='#777' />
    <LanguageGroup />
    <GatsbyLinkButton to='/skills/' title='DETAILS' />
  </CategoryContainer>
);
/*
    <Description>
      現在はTypescript + Reactをメインで使用しています。Sassは使用しますが、主にCSS in
      JSモジュール(emotion)を使うことが多いです。
      SIer時代はバックエンドをJava、フロントエンドをJavascript(ES5以前)とフラッシュを使って開発していました。また、Android
      Studio(Java)を使ったAndroidアプリの開発も経験があります。
    </Description>
    */
export default Component;
